import { type FC, useContext } from "react";
import { Barcode } from "../../Barcodes/Barcode";
import { DragDropComponentErrorContext } from "../../Forms/DragDrop/DragDropComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { createStyleFromPadding } from "../../Forms/PaddingInput";

export const ReceiptBarcodeComponent: FC<ComponentOptions> = ({ style }) => {
    const { invoiceNo } = useContext(DragDropDataContext);

    const error = useContext(DragDropComponentErrorContext);

    if(typeof invoiceNo !== "string") {
        return error;
    }

    return (
        <div
            className="receipt-barcode"
            style={style.padding ? createStyleFromPadding(style.padding) : undefined}
        >
            <Barcode
                value={`R${invoiceNo}`}
                height={40}
            />
        </div>
    );
};
